import { formatDistanceToNow, isToday, isYesterday, isTomorrow, parseISO, format } from 'date-fns';

/**
 * Format a date as a relative time string (e.g., "2 days ago", "in 3 hours")
 * Falls back to a formatted date for dates older than 30 days
 */
export function formatRelativeDate(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;
  const now = new Date();
  
  // Special cases for today, yesterday, tomorrow
  if (isToday(date)) {
    return 'today';
  }
  
  if (isYesterday(date)) {
    return 'yesterday';
  }
  
  if (isTomorrow(date)) {
    return 'tomorrow';
  }
  
  // Calculate the difference in milliseconds
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.abs(diffInMs / (1000 * 60 * 60 * 24));
  
  // For dates within 30 days, use relative format
  if (diffInDays <= 30) {
    const relativeTime = formatDistanceToNow(date, { addSuffix: true });
    
    // Clean up the output to match the desired format
    // "2 days ago" instead of "about 2 days ago"
    return relativeTime.replace(/^about /, '');
  }
  
  // For older dates, use a formatted date
  return format(date, 'MMM d, yyyy');
}

/**
 * Format a date for display in a consistent format
 */
export function formatDate(dateInput: string | Date, formatString: string = 'MM/dd/yyyy'): string {
  const date = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;
  return format(date, formatString);
} 